import { createContext, useEffect, useRef, useState } from 'react';

import { useSnackbar } from '@new-components/elements';

import { OnlineManagerProviderProps, UseOnlineManagerReturn } from './types';

const OnlineManagerContext = createContext<UseOnlineManagerReturn>({
  isOnline: true,
});

function OnlineManagerProvider(props: OnlineManagerProviderProps) {
  const { children } = props;

  const { onOpen } = useSnackbar();
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const prevIsOnline = useRef(isOnline);

  useEffect(() => {
    function handleNetworkChange() {
      setIsOnline(navigator.onLine);

      if (prevIsOnline.current !== navigator.onLine) {
        onOpen({
          message: navigator.onLine ? 'Online' : 'Offline',
          severity: navigator.onLine ? 'success' : 'warning',
        });
        prevIsOnline.current = navigator.onLine;
      }
    }

    window.addEventListener('online', handleNetworkChange);
    window.addEventListener('offline', handleNetworkChange);

    return () => {
      window.removeEventListener('online', handleNetworkChange);
      window.removeEventListener('offline', handleNetworkChange);
    };
  }, [onOpen]);

  return (
    <OnlineManagerContext.Provider value={{ isOnline }}>
      {children}
    </OnlineManagerContext.Provider>
  );
}

function useOnlineManager() {
  return {};
}

export { useOnlineManager, OnlineManagerProvider };
